module.exports = __webpack_public_path__ + "img/68.d4423fe4.jpg";